import { useCallback, useMemo } from 'react';
import { Domingo } from '@fiverr-private/domingo';
import { getContext } from '@fiverr-private/fiverr_context';
import { openFipMigrationModal, buildRedirectQueryParameters, ModalType } from '@fiverr-private/pro_migration';
import { mixpanel } from '@fiverr-private/obs';
import { sendBigQueryEvent } from '../../../utils/bigQuery';

// TODO: modify and export this method from @fiverr-private/pro_migration PR: #2391
export const shouldDisplayMigrationPopup = (): boolean => {
    const { userId, organizationId, experience } = getContext();
    const isNoneBusinessUser = userId && !organizationId;

    if (window && 'userJustMigratedToFib' in window && window.userJustMigratedToFib) {
        return false;
    }

    if (isNoneBusinessUser && experience.isBusiness) {
        return true;
    }

    return false;
};

/**
 * @param {object} params
 * @param {string} params.source
 * @param {string} params.trigger
 * @param {string} params.mpEvent
 * @param {object} params.bqEvent
 * @returns
 */
export const useFibMigrationModal = ({ mpEvent, bqEvent, source, trigger }) => {
    const { userId } = getContext();
    const isBrowser = typeof window !== 'undefined';
    const supportMigrationModal = useMemo(
        () => (userId && isBrowser ? shouldDisplayMigrationPopup() : false),
        [userId, isBrowser]
    );

    const triggerMigrationModal = useCallback(() => {
        if (mpEvent) {
            mixpanel.track(mpEvent, {
                source,
                trigger,
            });
        }
        if (bqEvent) {
            sendBigQueryEvent(bqEvent);
        }

        const businessHomePageUrl = Domingo(getContext().url)
            .removePath()
            .pro()
            .path('root', {}, { query: { source } }).url;

        const redirectToBusinessHomepage = () => window.location.assign(businessHomePageUrl);

        openFipMigrationModal({
            variant: ModalType.SeamlessUpgradeToPro,
            payload: {
                source,
                biEnrichment: {
                    pageName: source,
                    pageElementName: 'header',
                    trigger,
                },
                onSuccess: ({ balanceInUsdCents }) => {
                    const redirectUrl = buildRedirectQueryParameters({
                        redirectUrl: businessHomePageUrl,
                        balanceInUsdCents,
                    });
                    window.location.assign(redirectUrl);
                },
                onClose: redirectToBusinessHomepage,
                onSkip: redirectToBusinessHomepage,
            },
        });
    }, [source, trigger, mpEvent, bqEvent]);

    return {
        supportMigration: supportMigrationModal,
        triggerMigrationModal,
    };
};
